import { SubCategoryCode } from 'config-request/src/interfaces/feature-list';
import { defineStore } from 'pinia';
import { useFeatureListStore } from './feature-list';
import { useInteriorStore } from './interior';
export const usePopupStore = defineStore('popup', {
    getters: {
        getPopupData() {
            const featureListStore = useFeatureListStore();
            const optionMap = featureListStore.data?.option_map;
            const optionCodeCategoryMap = featureListStore.optionCodeCategoryMap;
            // === title ===
            // color wheel exterior-custom key interior-custom: option_map[optionCode].name
            // interior: option_combine_map[combinedKey](interiorStore.currentData.materialData.name)
            // === title ===
            // === price ===
            // color wheel exterior-custom key interior-custom: option_map[optionCode].price
            // interior: option_combine_map[combinedKey](interiorStore.currentData.combinedData?.price)
            // === price ===
            // === tip ===
            // color wheel key : option_map[optionCode].detail_desc_url
            // interior: option_combine_map[combinedKey].detail_desc_url
            // === tip ===
            const interiorStore = useInteriorStore();
            return (optionCode) => {
                const categoryCode = optionCodeCategoryMap?.[optionCode];
                if (categoryCode &&
                    categoryCode.subCategory === SubCategoryCode.Interior) {
                    return {
                        title: interiorStore.currentData.combinedData?.name,
                        price: interiorStore.currentData.combinedData?.price,
                        withTip: !!interiorStore.currentData.materialData?.detail_desc_url,
                        tipTitle: interiorStore.currentData.materialData?.name,
                        tipPrice: interiorStore.currentData.materialData?.price,
                    };
                }
                return {
                    title: optionMap?.[optionCode]?.name,
                    price: optionMap?.[optionCode]?.price,
                    withTip: !!optionMap?.[optionCode]?.detail_desc_url,
                    tipTitle: optionMap?.[optionCode]?.name,
                    tipPrice: optionMap?.[optionCode]?.price,
                };
            };
        },
    },
});
